import { render, staticRenderFns } from "./OsStatisticsCardParticipantsPerDay.vue?vue&type=template&id=53f2fbc9&scoped=true"
import script from "./OsStatisticsCardParticipantsPerDay.vue?vue&type=script&lang=ts"
export * from "./OsStatisticsCardParticipantsPerDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2fbc9",
  null
  
)

export default component.exports